import React from "react";
import HelpModal from "common/HelpModal.jsx";

const SoftwareAdminHelpModal = () => (
  <HelpModal
    title="Software Packages"
    content={() => (
      <>
        <p>
          List of installed software packages, with the following information:
        </p>
        <ul>
          <li>
            <b>NAME</b>: Package name. Possible values: bqnos, kernel,
            bqnkernel, linux, gui and bqn.
          </li>
          <li>
            <b>VERSION</b>: Package version.
          </li>
          <li>
            <b>ACTIVE</b>: Checked if the software package is being used right
            now by the BQN node.
          </li>
          <li>
            <b>BOOT</b>: Checked if the software package will be used when the
            BQN node boots. To change the one to boot click on any of the
            deselected packages
          </li>
          <li>
            <b>ACTIONS</b>: Reload action to make the package active (right now
            available for bqn package only).
          </li>
        </ul>
        <p>
          Click on the <i className="material-icons valign-icon">cached</i> icon
          to reload and activate the corresponding package. Note that installing
          a software package does not activate it, and it needs to be loaded.
          Some packages (bqnos, kernel, bqnkernel, linux, gui) require a system
          reboot in order to activate them.
        </p>

        <p>
          Press the <i className="material-icons valign-icon">more_vert</i> icon
          and then select the <b>Install...</b> option to upload a new software
          package provided by Bequant.
        </p>
        <p>
          Click on the <i className="material-icons valign-icon">refresh</i>{" "}
          icon to refresh software information.
        </p>
      </>
    )}
  />
);

export default SoftwareAdminHelpModal;
